var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTurbineSapling = function SvgTurbineSapling(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 106 170"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E6EBED",
    d: "M60.5 170c21.815 0 39.5-2.239 39.5-5s-17.685-5-39.5-5-39.5 2.239-39.5 5 17.685 5 39.5 5Z",
    opacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#CDD7DC",
    d: "m54.137 163.044-6-114.23h-3.14l-2.88 114.23s3.54 1.832 12.02 0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#9FA6AD",
    d: "M46.945 54.192s39.632 29.93 45.423 28.86c5.79-1.07-30.782-29.328-30.782-29.328s-10.947-1.79-14.64.468Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#848A90",
    d: "m83.165 71.069-4.192 4.938a92.024 92.024 0 0 0 8.55 5.071l2.46-3.26c-1.713-1.926-4.12-4.27-6.818-6.75Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#9FA6AD",
    d: "M44.892 55.053S2.106 80.491.928 86.183C-.25 91.872 39.56 68.758 39.56 68.758s6.008-9.408 5.332-13.706Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#848A90",
    d: "m14.917 82.052-2.877-5.979a98.767 98.767 0 0 0-8.134 6.38l2.02 3.63c2.476-.955 5.6-2.388 8.99-4.03Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#9FA6AD",
    d: "M46.555 54.052S51.228 4.717 47.51.3c-3.716-4.417-8.574 41.408-8.574 41.408s3.938 10.338 7.618 12.344Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#848A90",
    d: "m42.95 13.884 5.973 1.13c.084-3.174.002-6.35-.245-9.515l-3.784-.494a130.553 130.553 0 0 0-1.945 8.88Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#818181",
    d: "M48.107 48.05h-2.831a3.855 3.855 0 0 0-1.515.245c-.484.182-.928.46-1.307.818a4.006 4.006 0 0 0-.9 1.268 4.078 4.078 0 0 0-.356 1.522V53.965l-.264 9.096 10.704-.983.302-7.708V52.308a4.144 4.144 0 0 0-.234-1.58 4.083 4.083 0 0 0-.812-1.366 3.99 3.99 0 0 0-1.264-.942 3.918 3.918 0 0 0-1.523-.37Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.952 58.056a3.003 3.003 0 1 0 0-6.005 3.003 3.003 0 0 0 0 6.005Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#28C07F",
    d: "M105.002 87.917s0 20.586-6.046 27.448c-6.046 6.862-18.134 11.441-22.166 8.004-4.032-3.438-7.05-12.583-2.014-19.445 5.037-6.862 14.106-9.149 20.152-10.295 3.797-.813 7.296-2.797 10.074-5.712ZM28 104.39s11.928-6.106 20.602-5.09c8.675 1.015 15.182 5.09 17.35 12.212 2.167 7.121-2.457 11.305-7.59 13.231-5.42 2.036-11.927 0-16.266-8.141C37.756 108.46 28 104.39 28 104.39Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#0F9B7B",
    d: "M70.92 162.956s-3.012 1.49-7.737 0c0 0 2.213-15.432 2.213-19.846.6-4.07.22-8.215-1.107-12.126-2.208-5.515-12.154-14.335-14.363-16.54-2.209-2.205-6.63-5.511-4.422-5.511 2.209 0 7.737 2.201 13.244 7.716a156.724 156.724 0 0 1 9.946 11.029s5.524-11.029 8.831-14.331c3.307-3.301 12.155-13.23 15.47-11.029 3.316 2.201-5.524 6.615-7.737 8.82s-12.155 16.536-13.244 20.946c-1.09 4.411-1.094 30.872-1.094 30.872Z"
  })));
};
export default SvgTurbineSapling;